const invertedMessages = {
  Condition: 'external.rules.condition',
  'Enter values separated by commas or press Enter after each value':
    'external.rules.condition.placeholder',
};

export default invertedMessages;
